import React from "react";
import { getFormConfig } from "../Testing/FormTestData";
import { FormRuntime } from "../FormRuntime";
import { BorderStyle } from "../Utilities/FormDesignConstants";
import { DefaultOnOff } from "../Utilities/DefaultOnOff";
import { StoryNode } from "../../CommonUI/StoryBook/StoryData";
import { UIStyleConstants } from "../../rule-engine-core/Common/UIStyleConstants";

export const FormLayoutStories = [
    new StoryNode(
        () => {
            let ui = getFormConfig();
            return <FormRuntime form={ui} />;
        },
        "Form Builder",
        "Layout",
        "Default",
    ),
    new StoryNode(
        () => {
            let ui = getFormConfig();
            ui.formBackgroundColor = "red";
            return <FormRuntime form={ui} />;
        },
        "Form Builder",
        "Layout",
        "Default",
    ),
    new StoryNode(
        () => {
            let ui = getFormConfig();
            ui.defaultShowContainerBorder = true;
            ui.gapBetweenContainers = 100;

            return <FormRuntime form={ui} />;
        },
        "Form Builder",
        "Layout",
        "Inner Layout Space",
    ),
    new StoryNode(
        () => {
            let ui = getFormConfig();
            ui.defaultShowContainerBorder = true;
            ui.defaultInterControlSpacing = 50;
            return <FormRuntime form={ui} />;
        },
        "Form Builder",
        "Layout",
        "Inner Control Space",
    ),
    new StoryNode(
        () => {
            let ui = getFormConfig();
            ui.formBackgroundColor = "red";
            ui.defaultShowContainerBorder = true;
            ui.defaultInnerContainerMargin = 100;
            return <FormRuntime form={ui} />;
        },
        "Form Builder",
        "Layout",
        "Inner Margin",
    ),
    new StoryNode(
        () => {
            let ui = getFormConfig();
            ui.defaultInnerColumnMargin = 50;
            return <FormRuntime form={ui} />;
        },
        "Form Builder",
        "Layout",
        "Inner Column Margin",
    ),
    new StoryNode(
        () => {
            let ui = getFormConfig();
            ui.defaultShowContainerBorder = true;
            ui.defaultContainerBorderColor = UIStyleConstants.GRAY_DARK_COLOR;
            return <FormRuntime form={ui} />;
        },
        "Form Builder",
        "Layout",
        "Default Borders",
    ),
    new StoryNode(
        () => {
            let ui = getFormConfig();
            ui.defaultShowContainerBorder = true;
            ui.defaultContainerBorderStyle = BorderStyle.Dashed;
            return <FormRuntime form={ui} />;
        },
        "Form Builder",
        "Layout",
        "Default Borders Dashed",
    ),
    new StoryNode(
        () => {
            let ui = getFormConfig();
            ui.showLinesBetweenContainers = true;
            return <FormRuntime form={ui} />;
        },
        "Form Builder",
        "Layout",
        "Lines Between Layouts",
    ),
    new StoryNode(
        () => {
            let ui = getFormConfig();
            ui.defaultShowContainerBorder = true;
            ui.defaultContainerBorderColor = UIStyleConstants.GRAY_DARK_COLOR;
            ui.getContainers()[0].overrideFormBorderSettings = DefaultOnOff.On;
            ui.getContainers()[0].showContainerBorder = true;
            ui.getContainers()[0].containerBorderColor = "red";
            return <FormRuntime form={ui} />;
        },
        "Form Builder",
        "Layout",
        "Override Defaults In One Container",
    ),
    new StoryNode(
        () => {
            let ui = getFormConfig();
            ui.defaultShowContainerBorder = true;
            ui.defaultContainerBorderColor = UIStyleConstants.GRAY_DARK_COLOR;
            ui.getContainers()[0].overrideFormBorderSettings = DefaultOnOff.On;
            ui.getContainers()[0].showContainerBorder = false;
            return <FormRuntime form={ui} />;
        },
        "Form Builder",
        "Layout",
        "Turn Off Border In One Container",
    ),
];
